function initPasswordToggle(): void {
  const passwordToggles = document.querySelectorAll<HTMLElement>('[data-password-toggle]');

  passwordToggles.forEach((button) => {
    button.addEventListener('click', (e: Event) => {
      e.preventDefault();

      const inputId = button.dataset.passwordToggle;
      if (!inputId) return;

      const passwordInput = document.getElementById(inputId) as HTMLInputElement | null;
      if (!passwordInput) return;

      const isPasswordVisible = passwordInput.type === 'text';
      passwordInput.type = isPasswordVisible ? 'password' : 'text';

      button.classList.toggle('is-visible', !isPasswordVisible);
      button.setAttribute('aria-pressed', String(!isPasswordVisible));
      button.setAttribute(
        'aria-label',
        isPasswordVisible ? 'Passwort anzeigen' : 'Passwort ausblenden'
      );
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initPasswordToggle);
} else {
  initPasswordToggle();
}
